// src/components/Reusable/Modal/ReusableModal.jsx
import { Modal } from "antd";

const ReusableModal = ({
    title,
    open,
    onOk,
    onCancel,
    confirmLoading,
    children,
}) => {
    return (
        <Modal
            title={title}
            open={open}
            onOk={onOk}
            confirmLoading={confirmLoading}
            onCancel={onCancel}
            className="custom-modal"
        >
            {children}
        </Modal>
    );
};

export default ReusableModal;
